/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sanction_Other_InfractionsInputs */



/**
* | output |
* | --- |
* | "{count} other sanction(s) for different infractions in this event" |
*
* @param {Sanction_Other_InfractionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_other_infractions = /** @type {((inputs: Sanction_Other_InfractionsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Other_InfractionsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} autre(s) sanction(s) pour d'autres infractions dans cet événement`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} otra/s sanción/es por infracciones distintas en este evento`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} outra/s sanção/ões por infrações diferentes neste evento`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} altra/e sanzione/i per infrazioni diverse in questo evento`)
	return /** @type {LocalizedString} */ (`${i?.count} other sanction(s) for different infractions in this event`)
});